import styled from 'styled-components'

import { Title } from '../common/text/Title'

export const LoginTitle = styled(Title).attrs(props => ({
	color: "white",
	shadow: "0 0 2px black"
}))``